/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => typeof globalThis.fetch | undefined>(
  {
    native: () => require("./fetch").default,
    web: () => require("./fetch.web").default,
    default: () => require("./fetch.web").default,
  },
)();
